import { useEffect, useMemo, useState } from "react";

import './styles.css';
import { getStringWithParams } from "game/quests/utils";
import { translate } from "game/translate";

interface MissionTimerProps {
  endTimeMs: number;
}

export const MissionTimer: React.FC<MissionTimerProps> = ({ endTimeMs }) => {
    const [time, setTime] = useState(endTimeMs - Date.now());

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(endTimeMs - Date.now());
        }, 1000);
        return () => clearInterval(interval);
    }, [endTimeMs]);

    const text = useMemo(() => translate('mission_daily_timer'), []);

    const formatedTime = useMemo(() => {
        const hours = Math.max(0, Math.floor(time / 3600000));
        const minutes = Math.max(0, Math.floor((time % 3600000) / 60000));
        
        return getStringWithParams(text, hours.toString().padStart(2, '0'), minutes.toString().padStart(2, '0'));
    }, [time, text]);

    return (
        <div className="mission-timer">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g opacity="0.6">
                <path fillRule="evenodd" clipRule="evenodd" d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM7.25 3.75C7.25 3.33579 7.58579 3 8 3C8.41421 3 8.75 3.33579 8.75 3.75V7.5H12.5C12.9142 7.5 13.25 7.83579 13.25 8.25C13.25 8.66421 12.9142 9 12.5 9H8C7.58579 9 7.25 8.66421 7.25 8.25V3.75Z" fill="white"/>
                </g>
            </svg>
            <span className={`mission-timer-text${time <= 0 ? ' mission-timer-text--ended' : ''}`}>{formatedTime}</span>
        </div>
    );
}